var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"header"},[_c('Title',{attrs:{"bold":""}},[_vm._v(" To do List ")]),_c('Form',{staticClass:"header__form"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }